module.exports = __webpack_public_path__ + "img/product-banner7.39e57fad.jpg";